module.exports = "<td>{{ produto }}</td>\n<td width=\"100px\">{{ porcao }}</td>\n<td width=\"100px\">{{ calorias }}Kcal</td>\n<td width=\"100px\">R$ {% if promocao %}{{ valor_promocional | number_format(2,',','.') }}{% else %}{{ valor | number_format(2,',','.') }}{% endif %}</td>\n<td width=\"50px\"><a href=\"javascript:void(0)\" class=\"remove-product\" title=\"Remover produto\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></a></td>\n"


//////////////////
// WEBPACK FOOTER
// ./views/kits/dialog-cardapio/tr-cardapio-atual.twig
// module id = 43
// module chunks = 0